import { render } from "./DateTripTag.vue?vue&type=template&id=6b3f95fc&scoped=true"
import script from "./DateTripTag.vue?vue&type=script&lang=js"
export * from "./DateTripTag.vue?vue&type=script&lang=js"

import "./DateTripTag.vue?vue&type=style&index=0&id=6b3f95fc&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b3f95fc"]])

export default __exports__